<template>
  <div data-view="billing-accounts">
    <layout-logged-frame :title="$t('billing_accounts')" :has-aside="false">
      <template v-slot:content>
        <div class="form-wrapper">
          <panels-settings-billing-accounts />
        </div>
      </template>
    </layout-logged-frame>
  </div>
</template>
